import { Separator, Stack } from '@enechain/ecloud-designsystem'

import { AvailableDealSimulationSection } from '~/pages/Simulation/components/SimulationAndResultArea/AvailableDealSimulationSection'
import { MarginSimulationSection } from '~/pages/Simulation/components/SimulationAndResultArea/MarginSimulationSection'

export const SimulationAndResultArea: React.FC = () => {
  return (
    <Stack gap="6">
      <MarginSimulationSection />
      <Separator />
      <AvailableDealSimulationSection />
    </Stack>
  )
}
